import React, { forwardRef } from 'react';
import { Box } from '@mui/material';
import { observer } from 'mobx-react';
import FormEdit from './FormEdit';
import FormList from './FormList';
import FormList2 from './FormList2';
import FormSearch from './FormSearch';
import FormSearchAdvanced from './FormSearchAdvanced';
import FormListAdvanced from './FormListAdvanced';
import FormListSemiAdvanced from './FormListSemiAdvanced';

export const CRUD_COMPONENT_TYPE = {
  SEARCH: 'SEARCH',
  SEARCH_ADVANCED: 'SEARCH_ADVANCED',
  LIST: 'LIST',
  LIST2: 'LIST2',
  ADVANCED_LIST: 'ADVANCED_LIST',
  SEMI_ADVANCED_LIST: 'SEMI_ADVANCED_LIST',
  FORM: 'FORM',
};

const CRUDComponent = forwardRef(
  (
    {
      searchProps,
      listProps,
      formProps,
      hideForm = false,
      type,
      children,
      errors = null,
      warnings = null,
      sx = null,
    },
    ref,
  ) => {
    return (
      <Box {...(sx && { sx })}>
        {CRUD_COMPONENT_TYPE.SEARCH === type && (
          <Box>
            <FormSearch {...searchProps}>{children}</FormSearch>
          </Box>
        )}
        {CRUD_COMPONENT_TYPE.SEARCH_ADVANCED === type && (
          <Box>
            <FormSearchAdvanced {...searchProps} ref={ref}>
              {children}
            </FormSearchAdvanced>
          </Box>
        )}

        <Box>
          {CRUD_COMPONENT_TYPE.LIST === type && (
            <Box>
              <FormList {...listProps}>{children}</FormList>
            </Box>
          )}
          {CRUD_COMPONENT_TYPE.LIST2 === type && (
            <Box>
              <FormList2 {...listProps}>{children}</FormList2>
            </Box>
          )}
          {CRUD_COMPONENT_TYPE.SEMI_ADVANCED_LIST === type && (
            <Box>
              <FormListSemiAdvanced {...listProps}>
                {children}
              </FormListSemiAdvanced>
            </Box>
          )}
          {CRUD_COMPONENT_TYPE.ADVANCED_LIST === type && (
            <Box>
              <FormListAdvanced {...listProps}>{children}</FormListAdvanced>
            </Box>
          )}
        </Box>
        <Box>
          {CRUD_COMPONENT_TYPE.FORM === type && (
            <Box>
              <FormEdit
                errors={errors}
                warnings={warnings}
                {...formProps}
                hideForm={hideForm}>
                {children}
              </FormEdit>
            </Box>
          )}
        </Box>
      </Box>
    );
  },
);

export default observer(CRUDComponent);
